import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';

export function patch_CONFDEV_56476() {
	// scroll fix, see CONFDEV-56476
	// height: 100% causes the content body to scroll to the top when content body.focus() is called.
	const contentBody = window.tinymce.activeEditor.getBody();
	contentBody.style.height = 'auto';
}

export function patch_firefox() {
	if (window.tinymce.Env.gecko) {
		bind('rte-ready', patch_CONFDEV_56476);
	}
}
